export const contentConstants = {
  
    ANNOUNCEMENT_SUBMIT_START: "ANNOUNCEMENT_SUBMIT_START",
    ANNOUNCEMENT_SUBMIT_SUCCESS: "ANNOUNCEMENT_SUBMIT_SUCCESS",
    ANNOUNCEMENT_SUBMIT_FAILURE: "ANNOUNCEMENT_SUBMIT_FAILURE",
    UPDATE_SELECTED_ANNOUNCEMENT: "UPDATE_SELECTED_ANNOUNCEMENT"
  };
  